<template>
  <div>
    <div class="place">
		<div class="place-de">
			<div class="cent">
				<div class="pla-logo">
					<img src="../../assets/logo.png" />
				</div>
				<div class="pla-jit">
					<div class="tit"><img src="../../assets/map.png" />Official E-Mail</div>
					<div class="con">
						<ul>
							<li><img src="../../assets/icon3.png" />– info@fuelme.com.cn </li>
						
						</ul>
					</div>
				</div>
				<div class="pla-jit">
					<div class="tit"><img src="../../assets/icon4.png" />FuelMe Social</div>
					<div class="con">
						<ul>
							<li><img src="../../assets/phone.png" />– @FuelMe China </li>
							<li><img src="../../assets/twitter.png" />– @FuelMe_studio</li>
							<li><img src="../../assets/facebook.png" />– FuelMe Models  </li>
							<li><img src="../../assets/weibo.png" />– FuelMe Models  </li>
						</ul>
					</div>
				</div>
				<div class="pla-jit">
					<div class="tit">Quick find</div>
					<div class="con">
						<ul>
							<li><router-link to="/contact/contact">About Us</router-link> </li>
							<li><router-link to="/news/list">News </router-link></li>
							<li><router-link to="/product/list">Products Show </router-link></li>
							<li><router-link to="/contact/contact">Contact  </router-link> </li>
						</ul>
					</div>
				</div>
				<div class="pla-jit qub">
					<div class="tit">WeChat public platform</div>
					<div><img src="../../assets/card1.png"></div>
					<div class="con">
						<ul>
							<li><img src="../../assets/wechat.png" />FuelMe Models </li>
						
						</ul>
					</div>
				</div>
				
			</div>
		</div>
		<div class="pla-bot">
			<div class="cent">
				<div class="txt">Copyright  ©  FuelMe Models   </div>
				<div class="img"><img src="../../assets/facebook.png" ><img src="../../assets/phone.png" ><img src="../../assets/twitter.png" ><img src="../../assets/weibo.png" ><img src="../../assets/alipay.png" ><img src="../../assets/paypal.png" ></div>
			</div>
		</div>
		
  
    </div>

    <div class="bar-block"></div>
  </div>
</template>
<script>
import index from "@/assets/bar/index.png";
import index_action from "@/assets/bar/index_action.png";
import serve from "@/assets/bar/serve.png";
import serve_action from "@/assets/bar/serve_action.png";
import user from "@/assets/bar/user.png";
import user_action from "@/assets/bar/user_action.png";
import notice from "@/assets/bar/notice.png";
import notice_action from "@/assets/bar/notice_action.png";
import act from "@/assets/bar/act.png";
import act_action from "@/assets/bar/act_action.png";


export default {
  data() {
    return {
      barBtn: 0,
      barList: [
        {
          name: "首页",
          path: "/index/home",
          icon: index,
          icon_action: index_action,
        },
        {
          name: "服务",
          path: "/serve",
          icon: serve,
          icon_action: serve_action,
        }, {
          name: "政策公告",
          path: "/news",
          icon: notice,
          icon_action: notice_action,
        }, {
          name: "技能培训",
          path: "/act",
          icon: act,
          icon_action: act_action,
        },
        {
          name: "我的",
          path: "/user",
          icon: user,
          icon_action: user_action,
        },
      ],
    };
  },
  methods: {
    getBarBtn(index) {
      this.barBtn = index;
    },
  },
};
</script>

<style lang='scss' scoped>
.place{
	height: 444px;
	img{
		image-rendering: -webkit-optimize-contrast;
	}
	.cent{
		font-size: 14px;
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
	}
	.place-de{
		height: 240px;
		border-bottom: 1px solid #dedede;
		padding: 60px;
		.pla-logo{
			img{
				width: 120px;
				height: 57px;
			}
			
		}
		.pla-jit{
			
			.tit{
				display: flex;
				justify-content: flex-start;
				margin-bottom: 20px;
				img{
					width: 28px;
					height: 28px;
					margin-right: 15px;
				}
			}
			.con{
				color: #6C6C6C;
				li{
					line-height: 40px;
					img{
						width: 18px;
						margin-left: 13px;
						margin-right: 15px;
					}
				}
			}
		}
		.qub{
			text-align: center;
			.tit{
				display: block;
			}
		}
	}
	.pla-bot{
		line-height: 80px;
		display: flex;
		.img{
			img{
				margin-left: 20px;
				height: 22px;
			}
		}
	}
}
</style>